import * as color from "../styles/color";
import AlertModal from "./AlertModal";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    video: {
        width: "100%",
        maxHeight: "200px",
        objectFit: "contain",
        borderRadius: "4px",
        marginBottom: "12px",
        backgroundColor: color.black,
    },
});

const strings = {
    title: "Video",
    uploadFileLabel: "Upload Video",
    permanentRequirements: "Must be .mp4",
    requirementsDivider: "|",
    unsetRequirement: "UNSET",
    save: "Save",
    errorMsg: "There was an error with the video selected. Please check the file and try again.",
};

class VideoUploader extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        hideTitle: PropTypes.bool,
        requirements: PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
        }),
        onUpdate: PropTypes.func.isRequired,
    };

    state = {
        fileUrl: "",
        showAlertModal: false,
        fileInputKey: Date.now(), // Used to manually reset file input on error
    };

    _file = undefined;

    componentWillUnmount() {
        if (this.state.fileUrl) {
            URL.revokeObjectURL(this.state.fileUrl);
        }
    }

    _handleFileChange = e => {
        if (this.state.fileUrl) {
            URL.revokeObjectURL(this.state.fileUrl);
        }
        const file = e.target.files[0];
        this._file = file;
        if (!file) {
            this.setState({ fileUrl: "" });
            this.props.onUpdate(undefined, undefined);
            return;
        }
        this.setState({ fileUrl: URL.createObjectURL(file) });
    };

    _handleDurationChange = e => {
        const durationMs = Math.trunc(e.currentTarget.duration * 1000);
        console.log(durationMs);
        this.props.onUpdate(this._file, durationMs);
    };

    _handleError = () => {
        if (this.state.fileUrl) {
            URL.revokeObjectURL(this.state.fileUrl);
        }
        this.setState({ showAlertModal: true, fileUrl: "", fileInputKey: Date.now() });
        this.props.onUpdate(undefined, undefined);
    };

    _getRequirementsText = () => {
        const widthRequirement =
            this.props.requirements && this.props.requirements.width
                ? `${this.props.requirements.width}px`
                : "";
        const heightRequirement =
            this.props.requirements && this.props.requirements.height
                ? `${this.props.requirements.height}px`
                : "";
        const dimensionRequirements =
            widthRequirement || heightRequirement
                ? ` ${strings.requirementsDivider} Dimensions: ${
                      widthRequirement ? widthRequirement : strings.unsetRequirement
                  } by ${heightRequirement ? heightRequirement : strings.unsetRequirement}`
                : "";
        return `${strings.permanentRequirements}${dimensionRequirements}`;
    };

    _handleCloseAlertModal = () => {
        this.setState({ showAlertModal: false });
    };

    render() {
        return (
            <>
                <div className={css(this.props.className)}>
                    {!this.props.hideTitle ? (
                        <h4>{this.props.title ? this.props.title : strings.title}</h4>
                    ) : null}
                    {this.state.fileUrl ? (
                        <video
                            className={css(styles.video)}
                            src={this.state.fileUrl}
                            controls
                            onDurationChange={this._handleDurationChange}
                            onError={this._handleError}
                        />
                    ) : null}
                    <FormGroup controlId="videoUpload">
                        <ControlLabel>{strings.uploadFileLabel}</ControlLabel>
                        <FormControl
                            key={this.state.fileInputKey}
                            type="file"
                            accept=".mp4"
                            onChange={this._handleFileChange}
                        />
                        <HelpBlock>{this._getRequirementsText()}</HelpBlock>
                    </FormGroup>
                </div>
                <AlertModal
                    show={this.state.showAlertModal}
                    alertMessage={strings.errorMsg}
                    handleClose={this._handleCloseAlertModal}
                />
            </>
        );
    }
}

export default VideoUploader;
